import { ReactNode } from 'react';
import { Thead, Tr, Th, Tbody } from '@chakra-ui/react';
import Table from 'components/layout/Table';

type Props = {
  children?: ReactNode;
};

export const ActivityTable = ({ children }: Props) => {
  const tableHeader = {
    fontWeight: '600',
    fontSize: '10px',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: 'brand.dark-green',
  };

  return (
    <Table>
      <Thead>
        <Tr>
          <Th sx={tableHeader}>Type</Th>
          <Th sx={tableHeader}>ID</Th>
          <Th sx={tableHeader}>Company</Th>
          <Th sx={tableHeader}>Status</Th>
          <Th sx={tableHeader}>Date</Th>
        </Tr>
      </Thead>
      <Tbody>{children}</Tbody>
    </Table>
  );
};
